import { render, staticRenderFns } from "./JeopardyV2.vue?vue&type=template&id=9eb05c6e&"
import script from "./JeopardyV2.vue?vue&type=script&lang=js&"
export * from "./JeopardyV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports